import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FurnitureandfittingService } from './furnitureandfitting.service';
import * as CryptoJS from 'crypto-js';
import { CommonService } from '../../../../shared/common.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';
@Component({
  selector: 'app-furnitureandfittings',
  templateUrl: './furnitureandfittings.component.html',
  styleUrls: ['./furnitureandfittings.component.scss']
})
export class FurnitureandfittingsComponent implements OnInit {
  Furnitureandfittingsform: FormGroup;
  fittingid: any
  APPeriodId: any;
  tangibleAssetsValidation: any;
  isJump: any;
  NormalRoutng: boolean;
  showBubbledata;any
  constructor(private formbuilder: FormBuilder, private fittingservice: FurnitureandfittingService, public commonService: CommonService, private router: Router, public sidenav: SideNavService) { }
  ngOnInit() {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.commonService.getIncomeStatementsHeaders();
    this.CreateFurnitureandfittings();
    this.GetFurnitureandfittings(this.APPeriodId);
    this.clearfield();
    this.isJump = localStorage.getItem('isJump')
    //this.commonService.Showbubble.subscribe((data) => {
    //  if (data) {
        this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), this.APPeriodId).subscribe((data) => {
          this.commonService.showBubble = data[0].ImportStatus
          if (this.commonService.showBubble) {
            this.sidenav.setShowBubble(true)
            this.getLastyeardata();
          }
        })
    //  }
    //  else {
    //    this.showBubbledata = null
    //  }
    //})

    if (localStorage.getItem("SubmitStatus") == "true")
      this.Furnitureandfittingsform.disable()
  }

  CreateFurnitureandfittings() {
    this.Furnitureandfittingsform = this.formbuilder.group({
      APPeriodId: ['', []],
      FurnitureFittingsId: ['', []],
      MasterId: [null, []],
      PropertyPlantEquipmentGrossCost_End: ['', []],
      AccumulatedDepreciationImpairmentPropertyPlantEquipment_End: ['', []],
      PropertyPlantEquipment_Start: ['', []],
      PropertyPlantEquipment_End: ['', []],
      TotalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment: ['', []],
      DisposalsPropertyPlantEquipment: ['', []],
      AccumulatedDepreciationImpairmentPropertyPlantEquipment_Start: ['', []],
      IncreaseDecreaseInDepreciationImpairmentPropertyPlantEquipment: ['', []],
      DisposalsDecreaseInDepreciationImpairmentPropertyPlantEquipment: ['', []],
      PropertyPlantEquipmentGrossCost_Start: ['', []],
      PropertyPlantEquipmentFreeøtextComment: ['', []],
      CreatedBy: ['', []]
    })
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        this.Furnitureandfittingsform.reset()
      }
    })
  }

  InsertFurnitureandfittings() {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.Furnitureandfittingsform.controls['APPeriodId'].setValue(this.APPeriodId);
    this.Furnitureandfittingsform.controls['CreatedBy'].setValue(localStorage.getItem('LoginuserId'));
    const formdata = this.Furnitureandfittingsform.getRawValue()
    if (this.fittingid) {
      this.Furnitureandfittingsform.controls['FurnitureFittingsId'].setValue(this.fittingid);
    }
    this.fittingservice.insert(formdata).subscribe((data) => {
      this.Furnitureandfittingsform.markAsPristine()
      if (this.NormalRoutng)
        return true;
      var nextPage;
      nextPage = this.commonService.getNextNoteSelection("Furniture and fittings", this.commonService.NotesList)
      if (this.isJump == 'true')
        this.router.navigate(['/notes'])
      else if (nextPage == 'furnitureandfittings') {
        nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
        this.router.navigate([nextPage]);
      }
      else {
        this.router.navigate([nextPage]);
      }
    })
  }

  GetFurnitureandfittings(APPeriodId) {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.fittingservice.getfitting(this.APPeriodId).subscribe((data:any) => {
      if (data) {
        this.Furnitureandfittingsform.patchValue(data);
        this.fittingid = data.FurnitureFittingsId
      }
      this.commonService.getNotesData();
      this.commonService.gettotaltanagable()
      this.Furnitureandfittingsform.controls['PropertyPlantEquipmentGrossCost_End'].disable();
      this.Furnitureandfittingsform.controls['AccumulatedDepreciationImpairmentPropertyPlantEquipment_End'].disable();
      this.Furnitureandfittingsform.controls['PropertyPlantEquipment_Start'].disable();
      this.Furnitureandfittingsform.controls['PropertyPlantEquipment_End'].disable();
      this.Furnitureandfittingsform.controls['TotalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment'].disable();
      this.Furnitureandfittingsform.controls['DisposalsPropertyPlantEquipment'].disable();
      this.Furnitureandfittingsform.controls['AccumulatedDepreciationImpairmentPropertyPlantEquipment_Start'].disable();
      this.Furnitureandfittingsform.controls['IncreaseDecreaseInDepreciationImpairmentPropertyPlantEquipment'].disable();
      this.Furnitureandfittingsform.controls['DisposalsDecreaseInDepreciationImpairmentPropertyPlantEquipment'].disable();
      this.Furnitureandfittingsform.controls['PropertyPlantEquipmentGrossCost_Start'].disable();
      this.costcalculations();
      this.depreciation();
    })
  }
  getLastyeardata() {
    this.fittingservice.getlastyearfitting(this.APPeriodId).subscribe((data: any) => {
      debugger
      this.showBubbledata = data;
      this.Furnitureandfittingsform.controls['PropertyPlantEquipment_End'].setValue(data.PropertyPlantEquipment_End)
    })
  }

  save() {
    debugger
   // if (this.validation()) {
    if (true) {
      this.InsertFurnitureandfittings();
    }
    else {
      this.NormalRoutng = false;
      return false;
    }
    
    
  }
  back() {
    this.Furnitureandfittingsform.markAsPristine()
    var backpage;
    if (this.isJump == 'true')
      this.router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Furniture and fittings", this.commonService.NotesList)
      this.router.navigate([backpage]);
    }
  }

  costcalculations() {
  //  const propertyPlantEquipmentGrossCost_End = +this.Furnitureandfittingsform.get("PropertyPlantEquipmentGrossCost_Start").value;
  //  const accumulatedDepreciationImpairmentPropertyPlantEquipment_End = +this.Furnitureandfittingsform.get("TotalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment").value;
  //  const propertyPlantEquipment_Start = +this.Furnitureandfittingsform.get("DisposalsPropertyPlantEquipment").value;
  //  const total = propertyPlantEquipmentGrossCost_End + accumulatedDepreciationImpairmentPropertyPlantEquipment_End;
  //  this.Furnitureandfittingsform.get("PropertyPlantEquipmentGrossCost_End").setValue(total - propertyPlantEquipment_Start);
  //  this.Furnitureandfittingsform.get("PropertyPlantEquipment_Start").setValue(this.Furnitureandfittingsform.get("PropertyPlantEquipmentGrossCost_End").value - this.Furnitureandfittingsform.get("AccumulatedDepreciationImpairmentPropertyPlantEquipment_End").value);
  }
  depreciation() {
    //const totalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment = +this.Furnitureandfittingsform.get("AccumulatedDepreciationImpairmentPropertyPlantEquipment_Start").value;
    //const disposalsPropertyPlantEquipment = +this.Furnitureandfittingsform.get("IncreaseDecreaseInDepreciationImpairmentPropertyPlantEquipment").value;
    //const accumulatedDepreciationImpairmentPropertyPlantEquipment_Start = +this.Furnitureandfittingsform.get("DisposalsDecreaseInDepreciationImpairmentPropertyPlantEquipment").value;
    //const total = totalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment + disposalsPropertyPlantEquipment;
    //this.Furnitureandfittingsform.get("AccumulatedDepreciationImpairmentPropertyPlantEquipment_End").setValue(total - accumulatedDepreciationImpairmentPropertyPlantEquipment_Start);
    //this.Furnitureandfittingsform.get("PropertyPlantEquipment_Start").setValue(this.Furnitureandfittingsform.get("PropertyPlantEquipmentGrossCost_End").value - this.Furnitureandfittingsform.get("AccumulatedDepreciationImpairmentPropertyPlantEquipment_End").value);
  }


  validation() {
    debugger
    if (!this.commonService.MotorVehicles && !this.commonService.OfficeEquipment && this.commonService.AccountTemplateId != 11) {
      if (+this.Furnitureandfittingsform.controls["PropertyPlantEquipment_Start"].value + (this.commonService.tangibleAssetsValidation.LandAndBuilding_PropertyPlantEquipment_Start + this.commonService.tangibleAssetsValidation.Plantmachinery_PropertyPlantEquipment_Start) != +this.commonService.tangibleAssetsValidation.BalanceSheet_CY)
      {
        Swal.fire("Andica Accounts Production", "Sum of Net book value of Tangible Fixed Assets At " + this.commonService.EndDate + "  is different from the value reported in Balance Sheet for Tangible Fixed Assets in year " + this.commonService.StartYear + " both values must match. ", 'warning')
        return false
      }
      if (+this.Furnitureandfittingsform.controls["PropertyPlantEquipment_End"].value + (this.commonService.tangibleAssetsValidation.LandAndBuilding_PropertyPlantEquipment_End + this.commonService.tangibleAssetsValidation.Plantmachinery_PropertyPlantEquipment_End) != +this.commonService.tangibleAssetsValidation.BalanceSheet_LY)
      {
        Swal.fire("Andica Accounts Production", "Sum of Net book value of Tangible Fixed Assets At " + this.commonService.LastyearEndDate + "  is different from the value reported in Balance Sheet for Tangible Fixed Assets in year " + this.commonService.LastYear + " both values must match. ", 'warning')
        return false
      } else {
        return true
      }
    }
    return true
  }


  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.Furnitureandfittingsform.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight: 900'>You have unsaved data. </span><br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          debugger;
          this.NormalRoutng = true;
          if (this.save()) {
            return true;
          }
          else if (!this.NormalRoutng)
            return false;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.router.navigate(['/business']);

  }

}
